import React from 'react';
import { ThemeProvider } from '../styles/index.js';

const BaseProvider = props => {
  const { children, theme } = props;
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default BaseProvider;
